module.exports = __webpack_public_path__ + "res/media/receive-bg.13d7d942.mp3";